/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { useFoxTopUpStore } from "../../store";
import { BindActivityInfo, Detail } from "@/components/top-up/types";
import { FoxNormalRecharge } from "../fox-normal-recharge";
import { useCallback, useEffect, useState } from "react";
import { FoxGiftCoupon } from "../fox-gift-coupon";
import {
  findWelfareData,
  rulesContentList,
} from "@/components/top-up/help/activityUtil";
import { RechargeInputForm } from "../charge-input-form";
import { ActivityRechargeRadioList } from "../activity-recharge-radio-list";
import { PaymentWay } from "../payment-way";
import { CommonSecondTabsContent, CommonUpperPart } from "../../atom";
import { TopUpSecondTabs } from "@/components/top-up/components/second-tabs";
import { useTranslation } from "react-i18next";
import { RechargeVoucher } from "../recharge-voucher";
import ActivityRule from "@/components/top-up/components/activity-rule";
import { ActivityRuleAndCoupon, FoxCouponCode } from "./atom";
import { PaymentTypeCode } from "project-config/constants";
import { FoxStripeRecharge } from "../fox-stripe-recharge";
import {
  DEFAULT_RECHARGE_VIEW,
  DEBIT_CARD_VIEW,
  RechargeViewMode,
} from "../../constants/recharge-view";

export function AnimationBalanceRecharge({
  activityInfo,
}: {
  activityInfo?: BindActivityInfo;
}) {
  const { isZh } = useGlobalStore();
  const { setter } = useFoxTopUpStore();
  const payMethod = useFoxTopUpStore((state) => state.payMethod);
  const rechargeSecondActiveName = useFoxTopUpStore(
    (state) => state.rechargeSecondActiveName
  );
  const amount = useFoxTopUpStore((state) => state.amount);
  const verifyRechargeInfo = useFoxTopUpStore(
    (state) => state.verifyRechargeInfo
  );
  const { t } = useTranslation("topup");
  const [openActivityRuleDrawer, setOpenActivityRuleDrawer] = useState(false);
  const [rechargeViewMode, setRechargeViewMode] =
    useState<RechargeViewMode>(DEBIT_CARD_VIEW);
  const isStripeRechargeView =
    rechargeViewMode === DEFAULT_RECHARGE_VIEW &&
    payMethod === PaymentTypeCode.Stripe;
  const openCouponModal = () => {
    setter((state) => {
      state.showCouponCodeModal = true;
      if (verifyRechargeInfo.couponNO) {
        state.inputCode = verifyRechargeInfo.couponNO;
      }
    });
  };

  const welfareData =
    activityInfo && (findWelfareData(activityInfo, Number(amount)) as Detail);
  const isShowExtraGift =
    welfareData?.detailList && welfareData.detailList.length > 1;

  const getRechargeSecondTabList = useCallback(() => {
    let list = [];
    let rechargeSecondTabLis;
    if (isStripeRechargeView) {
      rechargeSecondTabLis = {
        label: t("topUp_balance_title"),
        key: "second-tab-fox-balance-recharge",
        children: (
          <>
            <CommonUpperPart>
              {/* <ActivityRuleAndCoupon>
                <FoxCouponCode onClick={openCouponModal}>
                  {t("fox_redeem_coupon")}
                </FoxCouponCode>
              </ActivityRuleAndCoupon> */}
              {/* 常规余额充值 */}
              <FoxStripeRecharge />
              {/* 充值兑换券 */}
              <RechargeVoucher />
            </CommonUpperPart>
            <PaymentWay
              rechargeViewMode={rechargeViewMode}
              onRechargeViewModeChange={setRechargeViewMode}
            />
          </>
        ),
      };
    } else if (activityInfo) {
      rechargeSecondTabLis = {
        label: isZh ? activityInfo.activityName : activityInfo.activityNameEn,
        key: "second-tab-fox-activity-recharge",
        children: (
          <>
            <CommonUpperPart>
              <ActivityRuleAndCoupon>
                <ActivityRule
                  ruleList={rulesContentList(activityInfo, isZh)}
                  openRuleDrawer={openActivityRuleDrawer}
                  changeDrawer={(val) => {
                    setOpenActivityRuleDrawer(val);
                  }}
                  activityInfo={activityInfo}
                />
                <FoxCouponCode onClick={openCouponModal}>
                  {t("fox_redeem_coupon")}
                </FoxCouponCode>
              </ActivityRuleAndCoupon>
              {/* 充值赠送券 */}
              <FoxGiftCoupon activityInfo={activityInfo} />
              <RechargeInputForm />
              {/* 充值兑换券 */}
              <RechargeVoucher />
              {isShowExtraGift && (
                <ActivityRechargeRadioList activityInfo={activityInfo} />
              )}
            </CommonUpperPart>
            <PaymentWay
              isShowExtraGift={isShowExtraGift}
              activityInfo={activityInfo}
              rechargeViewMode={rechargeViewMode}
              onRechargeViewModeChange={setRechargeViewMode}
            />
          </>
        ),
      };
    } else {
      rechargeSecondTabLis = {
        label: t("topUp_balance_title"),
        key: "second-tab-fox-balance-recharge",
        children: (
          <>
            <CommonUpperPart>
              <ActivityRuleAndCoupon>
                <FoxCouponCode onClick={openCouponModal}>
                  {t("fox_redeem_coupon")}
                </FoxCouponCode>
              </ActivityRuleAndCoupon>
              {/* 常规余额充值 */}
              <FoxNormalRecharge />
              <RechargeInputForm />
              {/* 充值兑换券 */}
              <RechargeVoucher />
            </CommonUpperPart>
            <PaymentWay
              rechargeViewMode={rechargeViewMode}
              onRechargeViewModeChange={setRechargeViewMode}
            />
          </>
        ),
      };
    }
    list.push(rechargeSecondTabLis);
    return list;
  }, [
    activityInfo,
    isShowExtraGift,
    isStripeRechargeView,
    payMethod,
    rechargeViewMode,
  ]);

  useEffect(() => {
    setter((state) => {
      state.rechargeSecondActiveName = getRechargeSecondTabList()[0].key;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activityInfo, isStripeRechargeView, payMethod]);

  return (
    <div>
      <CommonSecondTabsContent>
        <TopUpSecondTabs
          isForeign={true}
          tabsList={getRechargeSecondTabList()}
          activeKey={rechargeSecondActiveName}
          onChange={(k) => {
            setter((state) => {
              state.rechargeSecondActiveName = k;
            });
          }}
        />
      </CommonSecondTabsContent>
    </div>
  );
}
